import { useContext } from 'react';
import { DesignContext } from '../DesignContext';
import { CreativeTypes, MultiPageImageModel, MultiPageVideoModel } from '@bynder-studio/render-core';

type Props<T> = {
    loading: boolean;
    isUpdatedByVariation: boolean;
    creativeModelFactory: any;
    creativeModel: T;
    width: number;
    height: number;
    initCanvasRenderer: any;
    canvasRenderer: any;
    updatedPlaybackDuration: number;
    validationManager: any;
    creativeType: CreativeTypes;
    assetLoader: any;
    template: any;
    fonts: any[];
    creativeId: number;
    creativeVersionId: number;
    creativeName: string;
    isMultiVersionCreative: boolean;
    openDownloadModal: () => void;
    openUploadModal: () => void;
    recalculateShots: (newDurations?: { elementId: number; duration: number }[]) => Promise<Array<{ id: number }>>;
    setCurrentPageIndex: (index: number) => void;
    setUpdatedByVariation: () => void;
    setPausePlayback: () => void;
    setPlayPlayback: () => void;
    isPlaying: () => boolean;
};

export default function useDesign<T extends MultiPageImageModel | MultiPageVideoModel | undefined>() {
    const data = useContext<Props<T>>(DesignContext);

    const frameRate =
        data.creativeModel instanceof MultiPageVideoModel
            ? data.creativeModel?.getPlaybackDuration()?.getFrameRate() || 25
            : null;
    const duration =
        data.creativeModel instanceof MultiPageVideoModel
            ? data.creativeModel?.getPlaybackDuration()?.getDuration() || 0
            : 0;

    return {
        ...data,
        frameRate,
        duration,
        creativeModel: data.creativeModel as T,
    };
}
